/**
 * 팀 문화 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Heart, Lightbulb, Target, Users } from "lucide-react";

const values = [
  {
    icon: Heart,
    title: "커뮤니티 중심",
    description: "호주 한인 커뮤니티의 성장과 발전을 최우선으로 생각합니다.",
  },
  {
    icon: Users,
    title: "협업과 소통",
    description:
      "팀원 간의 열린 소통과 협업을 통해 더 나은 서비스를 만들어갑니다.",
  },
  {
    icon: Lightbulb,
    title: "혁신과 개선",
    description: "지속적인 혁신과 개선을 통해 사용자 경험을 향상시킵니다.",
  },
  {
    icon: Target,
    title: "사용자 만족",
    description: "사용자의 만족과 편의를 최우선으로 하는 서비스를 제공합니다.",
  },
];

export default function Team() {
  return (
    <>
      <Seo
        title="팀 문화 — OZK News"
        description="OZK News의 팀 문화와 가치관을 소개합니다."
        path="/team"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">팀 문화</h1>
            <p className="text-lg text-muted-foreground">
              OZK News의 가치관과 문화
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {values.map((value) => (
              <Card key={value.title}>
                <CardHeader>
                  <div className="w-12 h-12 rounded-lg bg-brand-primary/10 flex items-center justify-center mb-4">
                    <value.icon className="w-6 h-6 text-brand-primary" />
                  </div>
                  <CardTitle>{value.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card>
            <CardHeader>
              <CardTitle>함께 성장하는 팀</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-4">
                OZK News는 다양한 배경과 전문성을 가진 팀원들이 모여 호주 한인
                커뮤니티를 위한 최고의 플랫폼을 만들어가고 있습니다.
              </p>
              <p className="text-muted-foreground">
                우리는 사용자의 피드백을 소중히 여기며, 지속적인 개선과 혁신을
                통해 더 나은 서비스를 제공하기 위해 노력하고 있습니다.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
